import React from 'react';

interface Props {
    label: string;
    error?: string;
    children: React.ReactNode;
    hint?: string;
}

export default function FormField({ label, error, children, hint }: Props) {
    return (
        <div style={{ marginBottom: 16 }}>
            <label style={styles.label}>{label}</label>
            {children}
            {hint && <div style={styles.hint}>{hint}</div>}
            {error && <div style={styles.error}>{error}</div>}
        </div>
    );
}

export const inputStyle: React.CSSProperties = {
    width: '100%', padding: '10px 12px',
    border: '1.5px solid #ddd', borderRadius: 8,
    fontSize: 14, outline: 'none',
    boxSizing: 'border-box',
};

const styles: Record<string, React.CSSProperties> = {
    label: {
        display: 'block', fontSize: 13,
        fontWeight: 600, color: '#444',
        marginBottom: 6,
    },
    hint: { fontSize: 12, color: '#888', marginTop: 4 },
    error: { fontSize: 12, color: '#ef4444', marginTop: 4 },
};